import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { PrepareEffects } from '../../store/effects/prepare.effects';
import { ModalForbiddenEmailComponent } from './modals/modal-forbidden-email/modal-forbidden-email.component';
import { ModalForbiddenSubscriptionComponent } from './modals/modal-forbidden-subscription/modal-forbidden-subscription.component';
import { ModalPasswordRequiredComponent } from './modals/modal-password-required/modal-password-required.component';
import { DropboxPrepareMobileComponent } from './dropbox-prepare-mobile.component';
import { UploadMobileFooterComponent } from './upload-mobile-footer/upload-mobile-footer.component';
import { UploadMobileLinkParametersComponent } from './upload-mobile-link-parameters/upload-mobile-link-parameters.component';
import { UploadMobileSelectEmailComponent } from './upload-mobile-select-email/upload-mobile-select-email.component';
import { ModalUnknownUploadErrorComponent } from './modals/modal-unknown-upload-error/modal-unknown-upload-error.component';
import { UploadMobileEmailValidationComponent } from './upload-mobile-email-validation/upload-mobile-email-validation.component';
import { SmashVerificationCodeModule } from '@app/shared/modules/smash-verification-code/smash-verification-code.module';
import { SmashCardExpansionModule } from '@app/shared/modules/smash-card-expansion/smash-card-expansion.module';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';

@NgModule({
  declarations: [
    DropboxPrepareMobileComponent,
    ModalForbiddenEmailComponent,
    ModalForbiddenSubscriptionComponent,
    ModalPasswordRequiredComponent,
    ModalUnknownUploadErrorComponent,
    UploadMobileFooterComponent,
    UploadMobileSelectEmailComponent,
    UploadMobileLinkParametersComponent,
    UploadMobileEmailValidationComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    EffectsModule.forFeature([PrepareEffects,]),
    SmashVerificationCodeModule,
    SmashCardExpansionModule,
    SmashFormsModule
  ],
  providers: [
  ],
  exports: [
    DropboxPrepareMobileComponent,
  ]
})
export class DropboxPrepareMobileModule { }
